'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactMotion = require('react-motion');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Fragment = _react2.default.Fragment;

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Styles
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Container

var container = (0, _glamor.css)({
  width: '100%',
  margin: '0px auto'
});
var containerClass = container.toString();

var defaultContainer = (0, _glamor.css)({
  maxWidth: 1280,
  '@media(min-width: 768px)': {
    maxWidth: 1280
  }
});
var defaultContainerClass = defaultContainer.toString();

var block = (0, _glamor.css)({
  display: 'block'
});
var blockClass = block.toString();

var flex = (0, _glamor.css)({
  display: 'flex'
});
var flexClass = flex.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Bleed
var bleedContainer = (0, _glamor.css)({
  maxWidth: '100%',
  '@media(min-width: 768px)': {
    maxWidth: '100%'
  }
});
var bleedContainerClass = bleedContainer.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ goldenMajor, goldenMinor
var goldenMajor = (0, _glamor.css)({
  maxWidth: '96%',
  '@media(min-width: 768px)': {
    maxWidth: '62.5%'
  }
});
var goldenMajorClass = goldenMajor.toString();

var goldenMinor = (0, _glamor.css)({
  maxWidth: '96%',
  '@media(min-width: 768px)': {
    maxWidth: '37.5%'
  }
});
var goldenMinorClass = goldenMinor.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ threeQuarters
var threeQuarters = (0, _glamor.css)({
  maxWidth: '96%',
  '@media(min-width: 768px)': {
    maxWidth: '75%'
  }
});
var threeQuartersClass = threeQuarters.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Small
var smallContainer = (0, _glamor.css)({
  maxWidth: '96%',
  '@media(min-width: 768px)': {
    maxWidth: '50%'
  }
});
var smallContainerClass = smallContainer.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Tiny
var tinyContainer = (0, _glamor.css)({
  maxWidth: '96%',
  '@media(min-width: 768px)': {
    maxWidth: '37.5%'
  }
});
var tinyContainerClass = tinyContainer.toString();

// ------------------------------------------------------------------------------
// -------------------------------------------------------------------- Component
// ------------------------------------------------------------------------------
/* eslint-disable prefer-template */
/**
  * Container
  */
var Container = function Container(props) {
  return _react2.default.createElement(
    Fragment,
    null,
    !_lodash2.default.isUndefined(props.noFade) && props.noFade === true ? _react2.default.createElement(
      'div',
      _extends({
        className: '' + containerClass + (!_lodash2.default.isUndefined(props.block) && props.block === true ? ' ' + blockClass : ' ' + flexClass) + (_lodash2.default.isUndefined(props.tiny) && _lodash2.default.isUndefined(props.small) && _lodash2.default.isUndefined(props.bleed) ? ' ' + defaultContainerClass : '') + (!_lodash2.default.isUndefined(props.bleed) && props.bleed === true ? ' ' + bleedContainerClass : '') + (!_lodash2.default.isUndefined(props.small) && props.small === true ? ' ' + smallContainerClass : '') + (!_lodash2.default.isUndefined(props.tiny) && props.tiny === true ? ' ' + tinyContainerClass : '') + (!_lodash2.default.isUndefined(props.threeQuarters) && props.threeQuarters === true ? ' ' + threeQuartersClass : '') + (!_lodash2.default.isUndefined(props.goldenMajor) && props.goldenMajor === true ? ' ' + goldenMajorClass : '') + (!_lodash2.default.isUndefined(props.goldenMinor) && props.goldenMinor === true ? ' ' + goldenMinorClass : '') + (!_lodash2.default.isUndefined(props.className) ? ' ' + props.className : ''),
        style: _extends({}, props.style)
      }, _lodash2.default.omit(props, ['className', 'style', 'tiny', 'small', 'bleed', 'block', 'noFade', 'threeQuarters', 'goldenMajor', 'goldenMinor'])),
      props.children
    ) : _react2.default.createElement(
      _reactMotion.Motion,
      {
        defaultStyle: { opacity: 0 },
        style: { opacity: (0, _reactMotion.spring)(1, { stiffness: 210, damping: 33 }) }
      },
      function (fadeAnimation) {
        return _react2.default.createElement(
          'div',
          _extends({
            className: '' + containerClass + (!_lodash2.default.isUndefined(props.block) && props.block === true ? ' ' + blockClass : ' ' + flexClass) + (_lodash2.default.isUndefined(props.tiny) && _lodash2.default.isUndefined(props.small) && _lodash2.default.isUndefined(props.bleed) ? ' ' + defaultContainerClass : '') + (!_lodash2.default.isUndefined(props.bleed) && props.bleed === true ? ' ' + bleedContainerClass : '') + (!_lodash2.default.isUndefined(props.small) && props.small === true ? ' ' + smallContainerClass : '') + (!_lodash2.default.isUndefined(props.tiny) && props.tiny === true ? ' ' + tinyContainerClass : '') + (props.className ? ' ' + props.className : ''),
            style: _extends({}, fadeAnimation, props.style)
          }, _lodash2.default.omit(props, ['className', 'style', 'tiny', 'small', 'bleed', 'block', 'noFade', 'threeQuarters', 'goldenMajor', 'goldenMinor'])),
          props.children
        );
      }
    )
  );
};
/* eslint-enable prefer-template */

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Typing
// ------------------------------------------------------------------------------
Container.propTypes = process.env.NODE_ENV !== "production" ? {
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Specific props
  noFade: _propTypes2.default.bool,
  tiny: _propTypes2.default.bool,
  small: _propTypes2.default.bool,
  bleed: _propTypes2.default.bool,
  block: _propTypes2.default.bool,
  threeQuarters: _propTypes2.default.bool,
  goldenMajor: _propTypes2.default.bool,
  goldenMinor: _propTypes2.default.bool,

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Generic props
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types, react/no-unused-prop-types
  className: _propTypes2.default.string,
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
} : {};

Container.defaultProps = {
  noFade: undefined,
  className: undefined,
  style: {},
  tiny: undefined,
  small: undefined,
  bleed: undefined,
  block: undefined,
  threeQuarters: undefined,
  goldenMajor: undefined,
  goldenMinor: undefined
};

// ------------------------------------------------------------------------------
// ----------------------------------------------------------------------- Export
// ------------------------------------------------------------------------------
exports.default = Container;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/components/lib/Container.js
// module id = 311
// module chunks = 168707334958949